import { Tag, Space, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import bio from '../../../img/product/bio.svg';
import editIcon from '../../../img/edit-icon.svg';

export const BiologicalLegend = ({ height = 18 }) => (
  <img src={bio} alt={'biologique'} style={{ height: height }} />
);

export const ProductTypeLegend = ({ type, height = 18 }) => {
  const { t } = useTranslation('common');

  const legends = {
    serie: {
      text: t('legends.serie'),
      color: '#135200',
    },
    emballage: {
      text: t('legends.emballage'),
      color: '#95DE64',
      textColor: '#000',
    },
    nouveau: {
      text: t('legends.nouveau'),
      color: '#08979C',
    },
    fin: {
      text: t('legends.fin'),
      color: '#FFFFB8',
      textColor: '#000',
    },
    biological: {
      component: <BiologicalLegend height={height} />,
    },
  };

  const legend = legends[type];
  if (!legend) return null;

  if (legend.component) {
    return legend.component;
  }

  return (
    <Tag
      color={legend.color}
      className="rounded text-[9px] font-bold leading-none !mx-0 !px-1.5 !py-0.5"
      style={{ height: height, display: 'inline-flex', alignItems: 'center', color: legend.textColor }}
    >
      {legend.text}
    </Tag>
  );
};

const ProductLegends = () => {
  const { t } = useTranslation('common');

  const legends = [
    {
      key: 'emballage',
      text: t('legends.emballage'),
      color: '#95DE64',
      textColor: '#000',
      tooltip: t('legends.emballageTooltip'),
    },
    {
      key: 'nouveau',
      text: t('legends.nouveau'),
      color: '#08979C',
      textColor: '#fff',
      tooltip: t('legends.nouveauTooltip'),
    },
    {
      key: 'serie',
      text: t('legends.serie'),
      color: '#135200',
      tooltip: t('legends.serieTooltip'),
    },
    {
      key: 'fin',
      text: t('legends.fin'),
      color: '#FFFFB8',
      textColor: '#000',
      tooltip: t('legends.finTooltip'),
    },
  ];

  return (
    <div className="flex gap-4 items-center flex-wrap">
      <p className="text-[#000] text-[14px] font-medium">
        {t('legends.labels_title')}
      </p>
      <Space wrap size="small">
        <Tooltip
          title={t('legends.biologicalApprovalTooltip')}
          placement="top"
        >
          <div className="flex h-[38px] px-[6px] py-1 flex-col justify-center items-center gap-2 rounded cursor-help">
            <BiologicalLegend height={32} />
          </div>
        </Tooltip>
        {legends.map((legend) => (
          <Tooltip key={legend.key} title={legend.tooltip} placement="top">
            <Tag
              color={legend.color}
              className="rounded cursor-help text-[11px] font-bold"
              style={{
                color: legend.textColor,
              }}
            >
              {legend.text}
            </Tag>
          </Tooltip>
        ))}
        <Tooltip
          title={t('legends.editTooltip')}
          placement="top"
        >
          <div className="flex h-[28px] w-[28px] justify-center items-center rounded bg-[#FF4D4F] cursor-help">
            <img src={editIcon} alt="edit" className="w-4 h-4" />
          </div>
        </Tooltip>
      </Space>
    </div>
  );
};

export default ProductLegends;
